import { render, staticRenderFns } from "./AiGenerateModal.vue?vue&type=template&id=afd6bfb2&scoped=true"
import script from "./AiGenerateModal.vue?vue&type=script&lang=js"
export * from "./AiGenerateModal.vue?vue&type=script&lang=js"
import style0 from "./AiGenerateModal.vue?vue&type=style&index=0&id=afd6bfb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd6bfb2",
  null
  
)

export default component.exports